const GoogleCloudFunctions = () => {
  return <h1>GoogleCloudFunctions  </h1>;
};

export default GoogleCloudFunctions;